export default __webpack_public_path__ + "static/media/subscription_icon_active.ad18bc1b.svg";